import { render, staticRenderFns } from "./RELEmbarquesTrecho.vue?vue&type=template&id=174d5058&"
import script from "./RELEmbarquesTrecho.vue?vue&type=script&lang=js&"
export * from "./RELEmbarquesTrecho.vue?vue&type=script&lang=js&"
import style0 from "./RELEmbarquesTrecho.vue?vue&type=style&index=0&id=174d5058&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports